import angular from 'angular'

/**
 * A flex component.
 *
 * @deprecated ⚠️ This is DEPRECATED and will be removed in a future release.
 *
 */
angular.module('vend.ui').directive('vdFlex', function (elementService) {
  return {
    compile(tElement, tAttrs) {
      const classes = elementService.getClasses(tElement)
      const direction = tAttrs.vdFlexDirection
      const type = tAttrs.vdFlexType
      const justify = tAttrs.vdFlexJustify
      const align = tAttrs.vdFlexAlign

      classes.push('vd-flex')

      if (direction) {
        classes.push(`vd-flex--${direction}`)
      }

      if (type) {
        classes.push(`vd-flex--${type}`)
      }

      if (justify) {
        classes.push(`vd-flex--justify-${justify}`)
      }

      if (align) {
        classes.push(`vd-flex--align-${align}`)
      }

      tAttrs.$set('role', 'region')
      tAttrs.$set('class', classes.join(' '))
    },
  }
})
